import React, { Component } from 'react'
import {BrowserRouter as Router,Switch, Route} from 'react-router-dom'
import asyncComponent from '../components/AsyncComponent'
import {inLayout} from '../layouts/Layout/'

const Offer = asyncComponent(() => import("../routes/Offer"));
const GrupowkiOffer = asyncComponent(() => import("../routes/GrupowkiOffer"));
const NotFound = asyncComponent(() => import("../routes/NotFound"));
const Authorization = asyncComponent(() => import("../routes/Authorization"));
const Callback = asyncComponent(() => import("../routes/Callback"));

class RouterComponent extends Component {

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path='/login' component={Authorization}/>
          <Route exact path='/sign-in' component={Callback}/>
          <Route exact path="/:id" component={inLayout(Offer)}/>
          <Route exact path="/grupowki/:id" component={inLayout(GrupowkiOffer)}/>
          <Route component={inLayout(NotFound)}/>
        </Switch>
      </Router>
    );
  }
}

export default RouterComponent;



// WEBPACK FOOTER //
// ./src/components/RouterComponent.js